import { Component, ErrorInfo, ReactNode } from 'react';

import { reportBrowserError } from '@/observability';

import { ErrorView } from './ErrorPage';

interface Props {
  children: ReactNode;
}

interface State {
  error?: Error;
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error, hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportBrowserError('react-boundary', error, { boundary: 'application' });
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorView error={this.state.error} reportError={false} source='react-boundary' />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
